import ApiService from "../Services/ApiService";

/**
 * Espace client : les cours vus par séance (une ligne par séance).
 */
export interface ClientSessionInfo {
    sessionId: number;
    date: string | null;
    endDate: string | null;
    durationMinutes: number;
    amount: number | null;
    course: {
        id: number;
        isPunctualMonth: boolean;
        isRemote: boolean | null;
        subject: string | null;
        declarationStatus: string | null;
    } | null;
    teachr: { id: number; firstName: string; lastName: string } | null;
    childFirstName: string | null;
}

export interface ClientSessionsPage {
    sessions: ClientSessionInfo[];
    totalItems: number;
    page: number;
    limit: number;
}

export interface ClientDashboardSummary {
    nextSession: ClientSessionInfo | null;
    upcomingCount: number;
    month: {
        sessionsCount: number;
        totalMinutes: number;
        totalAmount: number;
        estimatedTaxCredit: number;
    };
}

export default abstract class ClientSessionRepository {
    public static getUpcoming(clientId: number, page = 0, limit = 10): Promise<ClientSessionsPage> {
        return ApiService.get(`/clients/v2/clients/${clientId}/upcoming_sessions?page=${page}&limit=${limit}`) as Promise<ClientSessionsPage>;
    }

    public static getPast(clientId: number, page = 0, limit = 10): Promise<ClientSessionsPage> {
        return ApiService.get(`/clients/v2/clients/${clientId}/past_sessions?page=${page}&limit=${limit}`) as Promise<ClientSessionsPage>;
    }

    public static getSummary(clientId: number): Promise<ClientDashboardSummary> {
        return ApiService.get(`/clients/v2/clients/${clientId}/dashboard_summary`) as Promise<ClientDashboardSummary>;
    }
}
